import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export function formatDatePt(iso) {
  if (!iso) return "";
  try {
    return format(parseISO(iso), "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
  } catch {
    return iso;
  }
}

export function formatDateShort(iso) {
  if (!iso) return "";
  try {
    return format(parseISO(iso), "dd/MM/yyyy", { locale: ptBR });
  } catch {
    return iso;
  }
}

export function maskPhoneBR(v) {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export function momentComplete(m) {
  if (m.not_applicable) return true;
  if (m.undecided) return true;
  const music = m.music || {};
  const hasMusic = !!music.track_name || !!m.manual_link;
  // Detalhes de execução são opcionais — música escolhida já conta como concluído.
  return hasMusic;
}
